import { render, staticRenderFns } from "./NominationCard.vue?vue&type=template&id=6a66e140&scoped=true&"
import script from "./NominationCard.vue?vue&type=script&lang=js&"
export * from "./NominationCard.vue?vue&type=script&lang=js&"
import style0 from "./NominationCard.vue?vue&type=style&index=0&id=6a66e140&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a66e140",
  null
  
)

export default component.exports